/**
 * Determines if the given albumFolder allows for entitlement of the whole set of photos
 *
 * @param {Object} albumFolder the albumFolder
 * @returns {*|boolean}
 */
export const isEntitledFreeWebGallery = albumFolder => {
  if (!albumFolder) {
    return false;
  }

  return (
    albumFolder?.is_web_gallery &&
    albumFolder?.web_gallery_price_per_photo &&
    !albumFolder?.web_gallery_price_per_photo?.value
  );
};
